import { forwardRef, useState } from "@wordpress/element";
import cx from "classnames";
import { ChevronDownIcon } from "../icons";

type Item = {
  title?: string,
  href?: string,
  active: boolean,
  children?: Item[]
};

const css = (active: boolean, style: "root" | "child") => {
  if (style == "root") {
    return cx(
      "swt-text-body-1 group block lg:leading-6 hover:text-ui-primary",
      active ? "text-ui-primary" : "text-ui-700"
    );
  } else {
    // child
    return cx(
      "swt-text-body-1 block pl-4 -ml-px border-l hover:border-ui-500 hover:text-ui-primary",
      active ? "text-ui-primary border-ui-500 " : "border-transparent text-ui-700"
    )
  }
};

export function ListMenu(props: { className?: string, open: boolean, children: any}) {
  return (
    <ul className={cx(props.className)}>
      {props.children}
    </ul>
  )
}

ListMenu.ParentItems = function(props: { href: string, title: string, active: boolean, children: any }) {
  let initialOpen = false;
  if (props.children) {
    if ("props" in props.children && "active" in props.children.props) {
      if (props.children.props.active) {
        initialOpen = true;
      }
    } else {
      props.children.forEach(child => {
        if (child && child.props && child.props.active) {
          initialOpen = true;
        }
      });
    }
  }

  let [isOpen, setIsOpen] = useState(initialOpen);

  return (
    <li>
      <button onClick={() => setIsOpen(!isOpen) } className={cx(css(props.active, "root"), "w-full flex items-center justify-between focus:outline-none relative")}>
        {props.title}
        <ChevronDownIcon
          className={cx("transition-transform", isOpen ? "rotate-180 transform" : "")}
        ></ChevronDownIcon>
      </button>
      {isOpen &&
        <ListMenu.Items>
          {props.children}
        </ListMenu.Items>
      }
    </li>
  )
}

ListMenu.Items = function(props: { children: any }) {
  return (
    <ul className={cx("mt-4 space-y-6 border-l lg:space-y-2 border-neutral-100")}>
      {props.children}
    </ul>
  )
}

ListMenu.Item = function(props: { href: string, title: string, onClick?: Function, active: boolean, style: "root" | "child" }) {
  const href = props.href ?? "#";

  const style = props.style ?? "child";

  const onClick = (e: any) => {
    if (props.onClick) {
      e.preventDefault();
      return props.onClick();
    } else {
      return true;
    }
  }

  return (
    <li>
      <a href={href} onClick={onClick} className={cx(css(props.active, style), "relative")}>
        {props.title}
        {props.active &&
        <span className={cx(
          "absolute h-px right-1 -bottom-px bg-gradient-to-r from-ui-primary to-ui-primary/0",
          style == "child" ? "left-4" : "left-0"
        )}></span>
      }
      </a>
    </li>
  )
}
